import styled from '@emotion/styled';

// no relevant space token for 368px. 368 comes from (gridSize = 8) * 46.
export const FocusedTaskContent = styled.div`
  width: 368px;
  margin: auto;
`;
